module.exports = __webpack_public_path__ + "static/media/notification.3f249626.svg";